export const getSiteRegion = () => import.meta.env.REACT_APP_SITE_REGION;
